/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Hls_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Manifest URL" |
*
* @param {Media_Import_Hls_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_hls_placeholder = /** @type {((inputs?: Media_Import_Hls_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Hls_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du manifeste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manifest-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL manifesto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL манифеста")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL del manifiesto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清单网址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マニフェストURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैनिफेस्ट यूआरएल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL do manifesto")
	return /** @type {LocalizedString} */ ("Manifest URL")
});